import React from 'react';
import './App.css'; 

const HomeEs = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.png" alt="Logo"/>
        <p className="centered-paragraph">
    ¡Navega por la web en tu reloj! Acceso rápido a favoritos. Mejora tu experiencia de navegación ahora con navegación web rápida, búsqueda inteligente y conectividad sin interrupciones para tu reloj inteligente. ¡Disfruta de una experiencia de navegación fluida y eficiente directamente desde tu muñeca!
</p>

        <a href='https://apps.apple.com/app/surfify-web-browser-on-watch/id6478813759?ppid=121505f9-a6b7-4285-b495-15bdd2bac71d'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUs'>Terms Of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a>
</div>
        </div>
        </>
     );
}
 
export default HomeEs;